/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UpdateProgramStatus$Params {
  programID?: number;
  statusID?: number;
  propagateStatus?: boolean;
  statusAnnotationText?: string;
}

export function UpdateProgramStatus(http: HttpClient, rootUrl: string, params?: UpdateProgramStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, UpdateProgramStatus.PATH, 'post');
  if (params) {
    rb.query('programID', params.programID, {});
    rb.query('statusID', params.statusID, {});
    rb.query('propagateStatus', params.propagateStatus, {});
    rb.query('statusAnnotationText', params.statusAnnotationText, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

UpdateProgramStatus.PATH = '/api/Supervisor/UpdateProgramStatus';
